<div class="comment-form">
  <ocp-avatar
    [userInitials]="userInitials()"
    [colorSeed]="colorSeed()"
    size="md"
    fontWeight="bold"
  />
  <div class="comment-form__body">
    <div class="comment-form__panel">
      <textarea
        #textarea
        class="comment-form__textarea"
        [ngModel]="message()"
        (ngModelChange)="message.set($event)"
        (input)="onTextareaInput($event)"
        (keydown.control.enter)="onAdd()"
        [attr.placeholder]="'comment-form.placeholder' | translate"
        [attr.aria-label]="'comment-form.placeholder' | translate"
        rows="3"
      ></textarea>
      <div class="comment-form__actions">
        <button
          hlmBtn
          size="lg"
          variant="default"
          type="button"
          class="comment-form__button comment-form__button--primary"
          [disabled]="!canSubmit()"
          (click)="onAdd()"
        >
          {{ 'comment-form.add-comment' | translate }}
        </button>
        <button
          hlmBtn
          size="lg"
          variant="secondary"
          type="button"
          class="comment-form__button comment-form__button--secondary"
          [disabled]="!canSubmit()"
          (click)="onCancel()"
        >
          {{ 'comment-form.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
